import moment from 'moment';

export const isValidDateGenerator = (
  disableFutureDates,
  disablePreviousDates,
) => date => {
  if (!date.isValid()) return false;

  if (disableFutureDates) {
    if (moment().diff(date, 'months') < 156) return false;
  }

  if (disablePreviousDates) {
    if (moment().diff(date, 'months') > 0) return false;
  }

  return true;
};
